/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Ticket_Parts_QtyInputs */

const en_ticket_parts_qty = /** @type {(inputs: Ticket_Parts_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qty ${i?.qty}`)
};

const ja_ticket_parts_qty = /** @type {(inputs: Ticket_Parts_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`数量 ${i?.qty}`)
};

const fr_ticket_parts_qty = /** @type {(inputs: Ticket_Parts_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qté ${i?.qty}`)
};

const de_ticket_parts_qty = /** @type {(inputs: Ticket_Parts_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anzahl ${i?.qty}`)
};

/**
* | output |
* | --- |
* | "Qty {qty}" |
*
* @param {Ticket_Parts_QtyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_parts_qty = /** @type {((inputs: Ticket_Parts_QtyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Parts_QtyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_parts_qty(inputs)
	if (locale === "ja") return ja_ticket_parts_qty(inputs)
	if (locale === "fr") return fr_ticket_parts_qty(inputs)
	return de_ticket_parts_qty(inputs)
});